import Vue from 'vue';
import Vuex from 'vuex';
import storage from './storage.plugin';

const SUPERADMINS = process.env.VUE_APP_SUPERADMINS;
const GUID = {
  Empty: '00000000-0000-0000-0000-000000000000',
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    IoTSelection: [],
    Order: {},
    Search: [],
    Scope: {},
    User: {},
    IsSuperAdmin: false,
    IsAdmin: false,
    IOTAccess: false,
    DynamicItineraryAccess: false,
    IsLogged: false,
    loading: false,
  },
  mutations: {
    LOGIN(state, user) {
      const { user: u = {} } = user;

      // There is users that doesn't generate a token but the authentication
      // method returns the email at least.
      if (u && u.email) {
        state.User = u;
        state.IsLogged = true;
      }
      // Only users that can generate tokens are considered as admin.
      if (user.token && u.guid !== GUID.Empty) {
        state.IsAdmin = true;
        state.IsSuperAdmin = SUPERADMINS.includes(u.email);
      }
    },
    LOGOUT(state) {
      state.User = {};
      state.IsLogged = false;
      state.IsAdmin = false;
    },
    IOT_SELECTION(state, tracker) {
      state.IoTSelection = tracker;
    },
    IOT_ACCESS(state, can) {
      state.IOTAccess = can;
    },
    DYNAMIC_ITINERARY_ACCESS(state, can) {
      state.DynamicItineraryAccess = can;
    },
    SET_ORDER(state, order) {
      state.Order = order;
    },
    SET_SCOPE(state, scope) {
      state.Scope = scope;
    },
    SET_ORDER_EVENTS(state, events) {
      state.Order = { ...state.Order, events };
    },
    SET_ORDER_INFO_EVENTS(state, infoEvents) {
      state.Order = { ...state.Order, infoEvents };
    },
    SET_ORDER_DOCUMENTS(state, documents) {
      state.Order = { ...state.Order, documents };
    },
    SET_ORDER_CONTENTS(state, contents) {
      if (contents) state.Order = { ...state.Order, items: contents };
    },
    SET_ORDER_HITS(state, hits) {
      state.Order = { ...state.Order, hits };
    },
    SET_SEARCH(state, results) {
      state.Search = results;
    },
    CLEAR_SCOPE(state) {
      state.Scope = { };
    },
    CLEAR_ORDER(state) {
      state.Order = { };
    },
    CLEAR_SEARCH(state) {
      state.Search = [];
    },
    START_LOADING(state) {
      state.loading = true;
    },
    END_LOADING(state) {
      state.loading = false;
    },
  },
  plugins: [
    storage,
  ],
});
